"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mapTotals = exports.mapItem = void 0;
var mapItem = function mapItem(item) {
  return {
    itemId: item.item_id,
    name: item.name,
    sku: item.sku,
    quantity: item.qty,
    price: item.price
  };
};
exports.mapItem = mapItem;
var mapTotals = function mapTotals(totals) {
  var _totals$total_segment, _totals$total_segment2, _totals$total_segment3, _totals$total_segment4, _totals$total_segment5, _totals$total_segment6;
  return {
    tax: totals === null || totals === void 0 ? void 0 : totals.base_tax_amount,
    productsTotalPrice: totals === null || totals === void 0 ? void 0 : totals.subtotal_incl_tax,
    cartTotalPrice: totals === null || totals === void 0 ? void 0 : totals.base_grand_total,
    shippingCost: totals === null || totals === void 0 ? void 0 : totals.base_shipping_incl_tax,
    discount: totals === null || totals === void 0 ? void 0 : totals.discount_amount,
    ePremia: totals === null || totals === void 0 ? void 0 : (_totals$total_segment = totals.total_segments.find(function (segment) {
      return segment.code === "rewardpoints_discount";
    })) === null || _totals$total_segment === void 0 ? void 0 : _totals$total_segment.value,
    ePremiaPoints: totals === null || totals === void 0 ? void 0 : totals.ePremiaPoints,
    couponCode: totals === null || totals === void 0 ? void 0 : totals.coupon_code,
    taxPercent: makeNumber(totals === null || totals === void 0 ? void 0 : (_totals$total_segment2 = totals.total_segments.find(function (segment) {
      return segment.code === "tax";
    })) === null || _totals$total_segment2 === void 0 ? void 0 : (_totals$total_segment3 = _totals$total_segment2.extension_attributes.tax_grandtotal_details) === null || _totals$total_segment3 === void 0 ? void 0 : (_totals$total_segment4 = _totals$total_segment3[0]) === null || _totals$total_segment4 === void 0 ? void 0 : (_totals$total_segment5 = _totals$total_segment4.rates) === null || _totals$total_segment5 === void 0 ? void 0 : (_totals$total_segment6 = _totals$total_segment5[0]) === null || _totals$total_segment6 === void 0 ? void 0 : _totals$total_segment6.percent)
  };
};
exports.mapTotals = mapTotals;
var makeNumber = function makeNumber(percent) {
  if (!percent) return null;
  return parseFloat("0.".concat(percent));
};